export interface BatchTohanBooksOrderDataCreateRequest {
  traderType: string
  branch: string
  isOutputAlreadyOrder: boolean
  rdoSetNumberType: string
  orderDateFrom: string
  orderDateTo: string
  batchType: string
}

export function BatchTohanBooksOrderDataCreateRequestToJSON(
  value: BatchTohanBooksOrderDataCreateRequest
): any {
  return {
    trader_type: value.traderType,
    branch: value.branch,
    is_output_already_order: value.isOutputAlreadyOrder,
    rdo_set_number_type: value.rdoSetNumberType,
    order_date_from: value.orderDateFrom,
    order_date_to: value.orderDateTo,
    batch_type: value.batchType
  }
}
